import React from 'react';
import BillingForm from '../components/BillingForm';

const Checkout = () => {
  return <BillingForm />;
};

export default Checkout;
